import { v4 as uuidv4 } from 'uuid';

export const setTraceHeaders = (headers: any) => {
    headers.set('x-selina-trace-id', uuidv4());
    headers.set('x-selina-caller-id', 'MS-PODIPO');
};
